module.exports = __webpack_public_path__ + "img/content-1.54a08893.png";